export const creditCardRepaymentMethodChangeExternal = {
    targetClientId: 'C02345N6',
};
